export { default as CharacteristicsButton } from './CharacteristicsButton';
